module.exports = __webpack_public_path__ + "img/gruppen_diagnose_04.33870f1d.png";